// src/providers/FeatureBaseProvider.js
import { useEffect } from 'react';
import { getUser } from 'utils/auth';

const FeatureBaseProvider = ({ children }) => {
  useEffect(() => {
    const User = getUser();

    if (!User) return;

    // Load FeatureBase script
    if (!document.getElementById('featurebase-sdk')) {
      const script = document.createElement('script');
      script.src = 'https://do.featurebase.app/js/sdk.js';
      script.id = 'featurebase-sdk';
      document.head.appendChild(script);
    }

    // Initialize FeatureBase
    const win = window;

    if (typeof win.Featurebase !== "function") {
      win.Featurebase = function () {
        (win.Featurebase.q = win.Featurebase.q || []).push(arguments);
      };
    }

    // Configure FeatureBase
    win.Featurebase("initialize_feedback_widget", {
      organization: "Cleri", // Your org name
      theme: "light", // or "dark", "auto"
      placement: "right", // Remove this line to hide floating button
      email: User?.userName, // Optional - if you have user data
      defaultBoard: "feedback", // Optional - your board name
      locale: "en",
      metadata: {
        userId: User?.employeeID+'',
        userRole: User?.roleName,
        page: window.location.pathname
      }
    });

    // Cleanup on unmount
    return () => {
      const existingScript = document.getElementById('featurebase-sdk');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []); // Re-initialize if user changes

  return children;
};

export default FeatureBaseProvider;